// extracted by mini-css-extract-plugin
export default {"toggleCheck":"OSduj02","s300":"NsP5aFJ","circle":"DZgqmNn","s200":"t0Vqmf0","icon":"KTIOWiU","input":"hytx9XA","hiddenLabel":"ZAEsw3c"};